import * as React from "react";
import * as _ from "lodash";
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from "react-redux";

import {
    IApplicationState, AppActionCreators,
    CenterActionCreators, ICrmState, CrmActionCreators, ICrmLookupDataResponse, IProductCenterResponse, IProductCenterForListResponse
} from "@nkr/store/index";

import { CenterAction } from "@nkr/enums/index";
import { ButtonGroup, Button, InputGroup, FormControl, ToggleButtonGroup, ToggleButton, Glyphicon, DropdownButton, MenuItem, ButtonToolbar } from "react-bootstrap";
import { ICenterSaturationListResponse, IProductOwnerResponse } from "@nkr/store/center/actions";
import { ICenterSaturation, IProductCenter, IBaseResponse, IProduct, IProductCenterForList, IProductOwner } from "@nkr/models/index";
import { Show, ProductActionType } from "./show";
import { CsvExportParams, ProcessHeaderForExportParams, ProcessCellForExportParams, GridApi, ColumnApi, GridReadyEvent } from "ag-grid-community";
import { toast } from "react-toastify";
import SaturationGrid from "./saturation-grid";
import { CenterActions } from "./common/center-actions";
import { FilterWrapper } from "./styles";
import { displayGroups } from './display-groups';
import { crmColumns } from './crm-columns';
import ProductCenter from "./product-center";
import DeleteProduct from "../../crm/account-plan/delete-product";
import CenterNotes from './center-notes';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface ICenterSaturationSettings {
    show: Show[],
    groups: number[],
    dateRecorded: Date
}

interface IOwnProps { }

interface IStateProps {
    crm: ICrmState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterSaturationList: () => Promise<ICenterSaturationListResponse>,
    getProductOwners: () => Promise<IProductOwnerResponse>,
    getCrmLookupData: () => Promise<ICrmLookupDataResponse>,
    getProductCenter: (centerId: number, productId: number) => Promise<IProductCenterResponse>,
    getProductCenters: () => Promise<IProductCenterForListResponse>,
    saveProductCenter: (centerId: number, productId: number, nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => Promise<IBaseResponse>,
    deleteProduct: (centerId: number, productId: number) => Promise<IBaseResponse>,
    updateProductIsActive: (productId: number, isActive: boolean) => Promise<IBaseResponse>,
    saveCenterNotes: (centerId: number, notes: string) => Promise<IBaseResponse>,
    saveCenterCategory: (centerId: number, category: string) => Promise<IBaseResponse>,
    saveSaturationAnnualGoal: (centerId: number, goal: number) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    centers: ICenterSaturation[],
    productOwners: Record<string, IProductOwner>,
    activeKey: string,
    centerId: number,
    productId: number,
    memberProspectToggle: number,
    centerSearch: string,
    targetedProduct: number,
    owner: number,
    show: Show[],
    groups: number[],
    product: {
        show: boolean,
        data: ICenterSaturation,
        product: IProduct,
        productCenter: IProductCenter,
        action: ProductActionType
    },
    deleteProduct: {
        show: boolean,
        center: ICenterSaturation,
        product: IProduct
    },
    crmOnly: boolean,
    currentColumns: string[],
    notes: {
        show: boolean,
        center: ICenterSaturation,
        targetedProductList: string[]
    },
    selectedCenters: {
        show: boolean,
        list: number[]
    },
    productCenters: IProductCenterForList[],
    category: string,
    gridApi: GridApi,
    columnApi: ColumnApi
}

const initialState: IState = {
    centers: [],
    productOwners: {},
    activeKey: "member-centers",
    centerId: 0,
    productId: 0,
    memberProspectToggle: 0,
    centerSearch: "",
    targetedProduct: 0,
    owner: 0,
    show: [Show.FullyUtilized, Show.Utilization],
    groups: __ENVIRONMENT__ == 'dev' ? displayGroups.map(x => x.id) : displayGroups.map(x => x.id),
    product: {
        show: false,
        data: null,
        product: null,
        productCenter: null,
        action: ProductActionType.Add
    },
    deleteProduct: {
        show: false,
        center: null,
        product: null
    },
    crmOnly: false,
    currentColumns: [],
    notes: {
        show: false,
        center: null,
        targetedProductList: []
    },
    selectedCenters: {
        show: false,
        list: []
    },
    productCenters: [],
    category: '',
    gridApi: null,
    columnApi: null
};

class CenterContainer extends React.Component<TProps, IState> {
    readonly state: IState = initialState;

    handlers = {
        [CenterAction.Cpr]: CenterActions.handleCpr,
        [CenterAction.Pairs]: CenterActions.handlePairs,
        [CenterAction.Login]: CenterActions.handleLogin,
        [CenterAction.Edit]: CenterActions.handleEdit,
        [CenterAction.Contacts]: CenterActions.handleContacts,
        [CenterAction.ActionCenter]: CenterActions.handleActionCenter
    };

    // gridApi: GridApi = null;
    // gridColumnApi: ColumnApi = null;

    componentDidMount = () => {
        var cookies = new Cookies();
        var nkrCenterSaturation = cookies.get('nkr-center-saturation') as ICenterSaturationSettings;

        if (nkrCenterSaturation != null && nkrCenterSaturation.dateRecorded == undefined) {
            cookies.remove('nkr-center-saturation');
            nkrCenterSaturation = null;
        }

        if (nkrCenterSaturation != null) {
            this.setState({
                show: nkrCenterSaturation.show,
                groups: nkrCenterSaturation.groups
            }, () => {
                this.getData();
            });
        } else {
            this.getData();
        }
    }

    getData = () => {
        this.props.showLoading("Getting centers, one moment please...").then(() => {
            Promise.all([
                this.props.getCenterSaturationList(),
                this.props.getProductOwners(),
                this.props.getCrmLookupData(),
                this.props.getProductCenters()
            ]).then(([saturationResponse, productOwnersResponse, crmLookupDataResponse, productCentersResponse]) => {
                this.setState({
                    centers: saturationResponse.data.results,
                    productOwners: productOwnersResponse.data.results,
                    productCenters: productCentersResponse.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    onGridReady = (event: GridReadyEvent) => {
        // this.gridApi = event.api;
        // this.gridColumnApi = event.columnApi;

        this.setState({
            gridApi: event.api,
            columnApi: event.columnApi
        }, () => {
            setTimeout(() => {
                this.showHideColumns();
            }, 1000);
        });
    }

    handleMemberProspectToggle = (memberProspectToggle: number) => {
        this.setState({
            memberProspectToggle
        });
    }

    handleCenterSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            centerSearch: e.currentTarget.value
        });
    }

    handleCenterSearchClear = () => {
        this.setState({
            centerSearch: ''
        });
    }

    handleTargetedProductChange = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        this.setState({
            targetedProduct: parseInt(e.currentTarget.value)
        });
    }

    handleOwnerChange = (e: React.FormEvent<HTMLSelectElement & FormControl>) => {
        this.setState({
            owner: parseInt(e.currentTarget.value)
        });
    }

    handleCenterAction = (id: number, action: CenterAction) => {
        if (this.handlers.hasOwnProperty(action)) {
            return this.handlers[action](id);
        }
    }

    handleSelect = (eventKey: any) => {
        window.location.href = '/admin/centers/' + eventKey;
    }

    handleViewAccountPlan = (centerId: number) => {
        window.location.href = `/admin/center/${centerId}/account-plan`;
    }

    handleCreateAccountPlan = (centerId: number) => {
        window.location.href = `/admin/center/${centerId}/account-plan`;
    }

    handleResetView = () => {

        let s = { ...initialState };
        delete s.centers;
        delete s.productOwners;
        delete s.gridApi;
        delete s.columnApi;

        this.setState({ ...s }, () => {
            this.showHideColumns();
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'center-saturation-view.csv',
            processHeaderCallback: (params: ProcessHeaderForExportParams) => {
                let headerName = params.column.getColDef().headerName;
                return headerName.replace(/\|/gi, ' ');
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (params.node.rowPinned == 'top') {
                    if (params.node.data.isSummary) {
                        if (colDef.headerName == 'Rank')
                            return '';

                        if (colDef.field == 'nkrLiaisonInitials')
                            return 'Summary >>';

                        if (colDef.colId == 'products' || colDef.colId == 'nextSteps')
                            return '';

                        if (colDef.colId == 'kflS')
                            return params.value.total;

                        if (colDef.colId == 'adVPUt')
                            return params.value.percent.toFixed(0) + '%';

                         if (colDef.colId == 'awPwlUt')
                            return params.value.percent.toFixed(0) + '%';

                        if (colDef.colId == 'awFUPfU')
                            return params.value.percent.toFixed(0) + '%';

                        if (colDef.colId == 'awFUPUt')
                            return params.value.percent.toFixed(0) + '%';

                        if (params.value) {
                            return (params.value.percent * 100).toFixed(0) + '%' + ' (' + params.value.total + ')';
                        }
                    } else {
                        if (colDef.headerName == 'Rank')
                            return '';

                        if (colDef.field == 'nkrLiaisonInitials')
                            return 'Product Owner >>';

                        if (params.value) {
                            return params.value.initials;
                        }
                    }
                }

                if (params.column.getColDef().headerName == 'R#')
                    return params.node.rowIndex + 1;

                if (typeof (params.value) == 'boolean') {
                    return params.value ? 'Yes' : 'No';
                }

                if (typeof (params.value) == 'number') {
                    return params.value ? Math.round(params.value) : '';
                }

                if (params.column.getColDef().colId == 'nextSteps') {
                    if (params.node.data.bizDevNextSteps && params.node.data.bizDevNextStepsTargetDate)
                        return params.node.data.bizDevNextSteps + ' (' + params.node.data.bizDevNextStepsTargetDate + ')';
                }

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    handleDeselectAllRows = () => {
        this.state.gridApi.deselectAll();
    }

    handleRowClicked = (centerId: number) => {
        if (this.state.selectedCenters.show == false) {
            let selectedCenters = _.cloneDeep(this.state.selectedCenters);

            if (selectedCenters.list.indexOf(centerId) >= 0) {
                selectedCenters.list = selectedCenters.list.filter(id => id != centerId);
            } else {
                selectedCenters.list.push(centerId);
            }

            this.setState({
                selectedCenters
            });
        }
    }

    handleShowOnlySelectedRows = () => {
        let selectedCenters = _.cloneDeep(this.state.selectedCenters);

        if (selectedCenters.show == true) {
            this.setState({
                selectedCenters: {
                    show: false,
                    list: []
                }
            });
        } else {
            selectedCenters.show = this.state.selectedCenters.list.length > 0 ? true : false;

            this.setState({
                selectedCenters
            });
        }
    }

    handleRemoveFromSelectedRows = (centerId: number) => {
        let selectedCenters = _.cloneDeep(this.state.selectedCenters);

        selectedCenters.list = selectedCenters.list.filter(id => id != centerId);
        selectedCenters.show = selectedCenters.list.length > 0;

        this.setState({
            selectedCenters
        });
    }

    handleShowChange = (e: any, item: Show) => {
        e.preventDefault();
        let show = [...this.state.show];

        if (show.indexOf(item) >= 0) {
            show = show.filter(id => id != item);
        } else {
            show.push(item);
        }

        this.setState({
            show
        }, () => {
            this.showHideColumns();
        })
    }

    handleShowAllGroups = () => {
        this.setState({
            groups: displayGroups.map(x => x.id)
        }, () => {
            this.showHideColumns();
        });
    }

    handleDisplayChange = (groupId: number) => {
        let groups = [...this.state.groups];

        if (groups.indexOf(groupId) >= 0) {
            groups = groups.filter(id => id != groupId);
        } else {
            groups.push(groupId);
        }

        this.setState({
            groups
        }, () => {
            this.showHideColumns();
        });
    }

    handleCrmClicked = () => {
        this.setState({
            crmOnly: !this.state.crmOnly
        }, () => {
            let columnsToNotHide = this.getColumnsToNotHide();

            if (this.state.crmOnly) {
                this.state.columnApi.setColumnsVisible(this.state.currentColumns, false);
                this.state.columnApi.setColumnsVisible(columnsToNotHide, true);
            } else {
                this.state.columnApi.setColumnsVisible(columnsToNotHide, false);
                this.state.columnApi.setColumnsVisible(this.state.currentColumns, true);
            }
        });
    }

    handleItemClicked = (centerId: number, productAlias: string, action: ProductActionType) => {
        let data = this.getFilteredOrderedSaturationList().find(x => x.id == centerId);
        let product = this.props.crm.productList.find(x => x.alias.toUpperCase() == productAlias)

        if (action == ProductActionType.Add) {
            this.setState({
                product: {
                    show: true,
                    data,
                    product,
                    productCenter: null,
                    action
                }
            });
        } else {
            this.props.getProductCenter(data.id, product.id).then(response => {
                let productCenter = response.data.results;

                this.setState({
                    product: {
                        show: true,
                        data,
                        product,
                        productCenter,
                        action
                    }
                });
            });
        }
    }

    handleProductSave = (nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => {
        if (this.state.product.action == ProductActionType.Add) {
            this.handleAddProductSave(nextSteps, targetDate, closeDate, closedBy);
        }

        if (this.state.product.action == ProductActionType.Edit) {
            this.handleEditProductSave(nextSteps, targetDate, closeDate, closedBy);
        }

        if (this.state.product.action == ProductActionType.Close) {
            this.handleCloseProductSave(nextSteps, targetDate, closeDate, closedBy);
        }

        if (this.state.product.action == ProductActionType.Reopen) {
            this.handleEditProductSave(nextSteps, targetDate, closeDate, closedBy);
        }
    }

    handleEditProductSave = (nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => {
        let centerId = this.state.product.data.id;
        let productId = this.state.product.product.id;

        this.setState({
            product: { ...this.state.product, show: false }
        }, () => {
            this.props.showLoading('Updating product plan, one moment please...').then(() => {
                this.props.saveProductCenter(centerId, productId, nextSteps, targetDate, closeDate, closedBy).then(response => {
                    if (response.data.success) {
                        this.props.getCenterSaturationList().then(response => {
                            this.setState({
                                centers: response.data.results
                            }, () => {
                                toast.success('Product plan updated successfully');
                            });

                            this.props.hideLoading();
                        });
                    } else {
                        toast.error('Could not update product plan.');
                    }
                });
            });
        });
    }

    handleProductOwnerClicked = (productId: number) => {
        let product = this.props.crm.productList.find(x => x.id == productId);

        return this.props.updateProductIsActive(productId, !product.isActive);
    }

    handleCategoryChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            category: e.currentTarget.value
        });
    }

    // crm: add product

    handleCancelAddProduct = () => {
        this.setState({
            product: { ...this.state.product, show: false }
        });
    }

    handleAddProductSave = (nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => {
        let centerId = this.state.product.data.id;
        let productId = this.state.product.product.id;

        this.setState({
            product: { ...this.state.product, show: false }
        }, () => {
            this.props.showLoading('Adding targeted product, one moment please...').then(() => {
                this.props.saveProductCenter(centerId, productId, nextSteps, targetDate, closeDate, closedBy).then(response => {
                    if (response.data.success) {
                        this.props.getCenterSaturationList().then(response => {
                            this.setState({
                                centers: response.data.results
                            }, () => {
                                toast.success('Targeted product added successfully');
                            });

                            this.props.hideLoading();
                        });
                    } else {
                        toast.error('Could not add targeted product.');
                    }
                });
            });
        });
    }

    // crm: close product

    handleConfirmCloseProduct = (centerId: number, productAlias: string) => {
        let data = this.getFilteredOrderedSaturationList().find(x => x.id == centerId);
        let product = this.props.crm.productList.find(x => x.alias.toUpperCase() == productAlias)

        this.props.getProductCenter(data.id, product.id).then(response => {
            let productCenter = response.data.results;

            this.setState({
                product: {
                    show: true,
                    data,
                    product,
                    productCenter,
                    action: ProductActionType.Close
                }
            });
        });
    }

    handleCloseProductSave = (nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => {
        let centerId = this.state.product.data.id;
        let productId = this.state.product.product.id;

        this.setState({
            product: { ...this.state.product, show: false }
        }, () => {
            this.props.showLoading('Closing targeted product, one moment please...').then(() => {
                this.props.saveProductCenter(centerId, productId, nextSteps, targetDate, closeDate, closedBy).then(response => {
                    if (response.data.success) {
                        this.props.getCenterSaturationList().then(response => {
                            this.setState({
                                centers: response.data.results
                            }, () => {
                                toast.success('Targeted product closed successfully');
                            });

                            this.props.hideLoading();
                        });
                    } else {
                        toast.error('Could not close targeted product.');
                    }
                });
            });
        });
    }

    handleCancelCloseProduct = () => {
    }

    // crm: delete product

    handleConfirmDeleteProduct = (centerId: number, productAlias: string) => {
        let center = this.getFilteredOrderedSaturationList().find(x => x.id == centerId);
        let product = this.props.crm.productList.find(x => x.alias.toUpperCase() == productAlias)

        this.setState({
            deleteProduct: {
                show: true,
                center,
                product
            }
        });
    }

    handleDeleteProduct = () => {
        let centerId = this.state.deleteProduct.center.id;
        let productId = this.state.deleteProduct.product.id;

        this.setState({
            deleteProduct: { ...this.state.deleteProduct, show: false }
        }, () => {
            this.props.showLoading('Deleting targeted product from center, one moment please...').then(() => {
                this.props.deleteProduct(centerId, productId).then(response => {
                    if (response.data.success) {
                        this.props.getCenterSaturationList().then(response => {
                            this.setState({
                                centers: response.data.results
                            }, () => {
                                toast.success('Targeted product deleted successfully');
                            });

                            this.props.hideLoading();

                        });
                    } else {
                        toast.error('Could not delete targeted product.');
                    }
                });
            });
        });
    }

    handleCancelDeleteProduct = () => {
        this.setState({
            deleteProduct: { ...this.state.deleteProduct, show: false }
        });
    }

    // notes

    handleShowNotes = (centerId: number) => {
        let center = this.state.centers.find(x => x.id == centerId);

        let targetedProductList = this.getTargetedProducts(centerId);

        this.setState({
            notes: {
                show: true,
                center,
                targetedProductList
            }
        });
    }

    handleCancelNotes = () => {
        this.setState({
            notes: { ...this.state.notes, show: false }
        });
    }

    handleSaveNotes = (centerId: number, notes: string) => {
        this.setState({
            notes: { ...this.state.notes, show: false }
        }, () => {
            this.props.showLoading('Saving center notes, one moment please...').then(() => {
                this.props.saveCenterNotes(centerId, notes).then(response => {
                    if (response.data.success) {
                        this.props.hideLoading();
                        toast.success('Center notes updated successfully');
                    } else {
                        toast.error('Could not update the center notes');
                    }
                });
            });
        });
    }

    // category

    handleSaveCategory = (centerId: number, category: string) => {
        this.props.saveCenterCategory(centerId, category).then(response => {
            if (response.data.success) {
                toast.success('Center category updated successfully');
            } else {
                toast.error('Could not update the center category');
            }
        });
    }

    handleSaveSaturationAnnualGoal = (centerId: number, goal: number) => {
        this.props.saveSaturationAnnualGoal(centerId, goal).then(response => {
            if (response.data.success) {
                this.props.getCenterSaturationList().then(() => {
                    toast.success('Center saturation annual goal updated successfully');
                });
            } else {
                toast.error('Could not update the center saturation annual goal');
            }
        });
    }

    // filters

    matchSaturationCenter = (center: ICenterSaturation) => {
        let step1 = center.name.toLowerCase().indexOf(this.state.centerSearch.toLowerCase()) >= 0;
        let step2 = center.alias.toLowerCase().indexOf(this.state.centerSearch.toLowerCase()) >= 0;
        let step3 = center.nkrLiaisonName.toLowerCase().indexOf(this.state.centerSearch.toLowerCase()) >= 0;

        return step1 || step2 || step3;
    }

    getCrmFilter = (center: ICenterSaturation) => {
        let list = crmColumns.map(x => x.dataColumn);

        let results: boolean[] = [];

        list.forEach(property => {
            results.push(center[property] == -1);
        });

        return results.filter(x => x == true).length > 0;
    }

    getFilteredOrderedSaturationList = () => {
        let filteredList = this.state.centers.filter(center => {
            let step1 = this.state.memberProspectToggle == 0 ? center.isParticipant == true : center.isParticipant == false;
            let step2 = this.state.centerSearch != "" ? this.matchSaturationCenter(center) : true;
            let step3 = this.state.crmOnly ? this.getCrmFilter(center) : true;
            let step4 = this.state.selectedCenters.show && this.state.selectedCenters.list.length > 0 ? this.state.selectedCenters.list.indexOf(center.id) >= 0 : true;
            let step5 = this.state.category != '' ? center.category == this.state.category : true;

            return step1 && step2 && step3 && step4 && step5;
        });

        return _.orderBy(filteredList, (center) => {
            return center.alias;
        });
    }

    // other

    getColumnsToNotHide = () => {
        let saturationList = this.getFilteredOrderedSaturationList();

        let columnsToNotHide: string[] = [];

        saturationList.forEach(row => {
            crmColumns.forEach(column => {
                if (row[column.dataColumn] == -1) {
                    if (columnsToNotHide.indexOf(column.gridColumn) == -1) {
                        columnsToNotHide.push(column.gridColumn);
                    }
                }
            });
        });

        return columnsToNotHide;
    }

    getTargetedProducts = (centerId: number) => {
        let center = this.state.centers.find(x => x.id == centerId);

        let results = this.props.crm.productList.map(product => {
            return center[product.property] == -1 ? product.name : '';
        }).filter(x => x != '');

        return results;
    }

    showHideColumns = () => {
        let showFullyUtilized = this.state.show.indexOf(Show.FullyUtilized) >= 0;
        let showUtilization = this.state.show.indexOf(Show.Utilization) >= 0;

        let visibleColumns: string[] = [];
        let hiddenColumns: string[] = [];

        for (let g = 0; g < displayGroups.length; g++) {
            let group = displayGroups[g];

            let show = this.state.groups.indexOf(group.id) >= 0;

            let cols = this.state.columnApi.getAllColumns().filter(x => x.getColId().indexOf(group.prefix) >= 0);
            let columns = cols.map(c => c.getColId());

            if (show) {
                visibleColumns = visibleColumns.concat(columns);
            } else {
                hiddenColumns = hiddenColumns.concat(columns);
            }

            if (show) {
                let fullyUtilizedCols = this.state.columnApi.getAllColumns().filter(x => x.getColId().indexOf(group.prefix) >= 0 && x.getColId().indexOf('fU') >= 0);
                let fullyUtilizedColumns = fullyUtilizedCols.map(c => c.getColId());

                if (showFullyUtilized) {
                    visibleColumns = visibleColumns.concat(fullyUtilizedColumns);
                } else {
                    hiddenColumns = hiddenColumns.concat(fullyUtilizedColumns);
                }

                let utilizationCols = this.state.columnApi.getAllColumns().filter(x => x.getColId().indexOf(group.prefix) >= 0 && x.getColId().indexOf('Ut') >= 0);
                let utilizationColumns = utilizationCols.map(c => c.getColId());

                if (showUtilization) {
                    visibleColumns = visibleColumns.concat(utilizationColumns);
                } else {
                    hiddenColumns = hiddenColumns.concat(utilizationColumns);
                }
            }
        }

        this.state.columnApi.setColumnsVisible(visibleColumns, true);
        this.state.columnApi.setColumnsVisible(hiddenColumns, false);

        this.setCookie();
    }

    setCookie = () => {
        var cookies = new Cookies();
        let { show, groups } = this.state;

        cookies.set('nkr-center-saturation', { show, groups, dateRecorded: new Date() }, { path: "/", domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    render = () => {
        const saturationList = this.getFilteredOrderedSaturationList();
        const productOwners = this.state.productOwners;

        const groups = _.sortBy(displayGroups, (item) => {
            return item.order
        });

        return (
            <>
                <FilterWrapper>
                    <div className='center-type' style={{ display: "flex", justifyContent: "center", marginRight: 20 }}>
                        <ButtonGroup bsSize="small">
                            <button className={this.state.memberProspectToggle == 0 ? "btn btn-primary btn-small active center-type" : "btn btn-default btn-small center-type"} onClick={() => this.handleMemberProspectToggle(0)}>Member Centers</button>
                            <button className={this.state.memberProspectToggle == 1 ? "btn btn-primary btn-small active center-type" : "btn btn-default btn-small center-type"} onClick={() => this.handleMemberProspectToggle(1)}>Prospect Centers</button>
                        </ButtonGroup>
                    </div>

                    <div className='name-search' style={{ display: "flex", justifyContent: "center", alignItems: 'center', marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>C:</div>
                        <div>
                            <FormControl
                                componentClass='select'
                                value={this.state.category}
                                onChange={this.handleCategoryChange}
                            >
                                <option value=''>- All -</option>
                                <option value='A'>A</option>
                                <option value='B'>B</option>
                                <option value='C'>C</option>
                                <option value='D'>D</option>
                            </FormControl>
                        </div>
                    </div>

                    <div className='name-search' style={{ display: "flex", justifyContent: "center", alignItems: 'center', marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <div>
                            <InputGroup bsSize="small">
                                <FormControl
                                    style={{ width: 150 }}
                                    placeholder="Filter list by name..."
                                    value={this.state.centerSearch}
                                    onChange={this.handleCenterSearchChange}
                                />
                                <InputGroup.Button>
                                    <Button bsStyle="danger" onClick={this.handleCenterSearchClear}>Clear</Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </div>
                    </div>

                    <div className='show-stuff' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 20 }}>
                        <div style={{ marginRight: 5 }}>Show:</div>
                        <div style={{ marginRight: 0 }}>
                            <ButtonToolbar>
                                <ToggleButtonGroup type="checkbox" name="swaps">
                                    <ToggleButton value={Show.FullyUtilized} className={this.state.show.indexOf(Show.FullyUtilized) >= 0 ? 'btn-primary btn-sm fully-utilized' : 'btn-sm fully-utilized'} disabled={this.state.crmOnly} onClick={(e) => this.handleShowChange(e, Show.FullyUtilized)}>Fully Utilized</ToggleButton>
                                    <ToggleButton value={Show.Utilization} className={this.state.show.indexOf(Show.Utilization) >= 0 ? 'btn-primary btn-sm fully-utilized' : 'btn-sm fully-utilized'} disabled={this.state.crmOnly} onClick={(e) => this.handleShowChange(e, Show.Utilization)}>Utilization</ToggleButton>
                                </ToggleButtonGroup>

                                <DropdownButton id='groups-dropdown' title={'Groups'} bsStyle={this.state.groups.length == displayGroups.length ? 'primary' : 'default'} bsSize='sm' disabled={this.state.crmOnly}>
                                    <MenuItem><label onClick={this.handleShowAllGroups} style={{ marginBottom: 0, fontWeight: 400 }}>- Show All -</label></MenuItem>
                                    {groups.map((group, index) => {
                                        let isChecked = this.state.groups.indexOf(group.id) >= 0;

                                        return (
                                            <MenuItem className={isChecked ? group.class : null}>
                                                <label onClick={() => this.handleDisplayChange(group.id)} style={{ marginBottom: 0, fontWeight: 400 }}>
                                                    <Glyphicon glyph={isChecked ? 'check' : 'unchecked'} style={{ marginRight: 10 }} />
                                                    {group.name}
                                                </label>
                                            </MenuItem>
                                        );
                                    })}
                                </DropdownButton>

                                <Button bsStyle={this.state.crmOnly ? 'primary' : 'default'} bsSize='sm' style={{ outline: 'none' }} title='Show only columns and centers with targets' onClick={this.handleCrmClicked}>{!this.state.crmOnly ? 'SUPPRESS' : 'UNSUPPRESS'}</Button>
                            </ButtonToolbar>
                        </div>
                    </div>

                    <div className='export' style={{ display: "flex", justifyContent: 'flex-end', alignItems: "center", marginRight: 20 }}>
                        <Button bsStyle={this.state.selectedCenters.show ? 'primary' : 'default'} bsSize="sm" disabled={this.state.selectedCenters.list.length == 0} onClick={this.handleShowOnlySelectedRows}>Selected Rows Only</Button>
                    </div>

                    <div className='export' style={{ display: "flex", justifyContent: 'flex-end', alignItems: "center", marginRight: 20 }}>
                        <Button bsStyle='danger' bsSize="small" onClick={this.handleResetView}>Reset View</Button>
                    </div>

                    <div className='export' style={{ display: "flex", justifyContent: 'flex-end', alignItems: "center" }}>
                        <Button bsSize="small" onClick={this.handleExport}>Export to Excel</Button>
                    </div>
                </FilterWrapper>

                <SaturationGrid
                    data={saturationList}
                    products={this.props.crm.productList}
                    productOwners={productOwners}
                    productCenters={this.state.productCenters}
                    gridApi={this.state.gridApi}
                    gridColumnApi={this.state.columnApi}
                    showHighlightedRowsOnly={this.state.selectedCenters.show}
                    onGridReady={this.onGridReady}
                    onDeselectAllRows={this.handleDeselectAllRows}
                    onShowOnlySelectedRows={this.handleShowOnlySelectedRows}
                    onItemClicked={this.handleItemClicked}
                    onCloseProduct={this.handleConfirmCloseProduct}
                    onDeleteProduct={this.handleConfirmDeleteProduct}
                    onShowNotes={this.handleShowNotes}
                    onSaveCategory={this.handleSaveCategory}
                    onSaveSaturationAnnualGoal={this.handleSaveSaturationAnnualGoal}
                    onRowClicked={this.handleRowClicked}
                    onProductOwnerClicked={this.handleProductOwnerClicked}
                    onRemoveFromSelectedRows={this.handleRemoveFromSelectedRows}
                />

                <ProductCenter
                    show={this.state.product.show}
                    center={this.state.product.data != null ? this.state.product.data.alias : ''}
                    product={this.state.product.product != null ? this.state.product.product.name : ''}
                    productCenter={this.state.product.productCenter}
                    staffList={this.props.crm.staffList}
                    action={this.state.product.action}
                    onSave={this.handleProductSave}
                    onCancel={this.handleCancelAddProduct}
                />

                <DeleteProduct
                    show={this.state.deleteProduct.show}
                    product={this.state.deleteProduct.product != null ? this.state.deleteProduct.product.name : ''}
                    center={this.state.deleteProduct.center != null ? this.state.deleteProduct.center.alias : ''}
                    onDelete={this.handleDeleteProduct}
                    onCancel={this.handleCancelDeleteProduct}
                />

                <CenterNotes
                    show={this.state.notes.show}
                    centerId={this.state.notes.center != null ? this.state.notes.center.id : 0}
                    centerAlias={this.state.notes.center != null ? this.state.notes.center.alias : ''}
                    notes={this.state.notes.center != null ? this.state.notes.center.notes : ''}
                    targetedProductList={this.state.notes.targetedProductList}
                    onSave={this.handleSaveNotes}
                    onCancel={this.handleCancelNotes}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        crm: appState.crm
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getCenterSaturationList: () => { return dispatch(CenterActionCreators.getCenterSaturationList()); },
        getProductOwners: () => { return dispatch(CenterActionCreators.getProductOwners()); },
        getCrmLookupData: () => { return dispatch(CrmActionCreators.getCrmLookupData()); },
        getProductCenter: (centerId, productId) => { return dispatch(CrmActionCreators.getProductCenter(centerId, productId)); },
        getProductCenters: () => { return dispatch(CrmActionCreators.getProductCenters()); },
        saveProductCenter: (centerId, productId, nextSteps, targetDate, closeDate, closedBy) => { return dispatch(CrmActionCreators.saveProductCenter(centerId, productId, nextSteps, targetDate, closeDate, closedBy)); },
        deleteProduct: (centerId, productId) => { return dispatch(CrmActionCreators.deleteProductCenter(centerId, productId)); },
        updateProductIsActive: (productId, isActive) => { return dispatch(CrmActionCreators.updateProductIsActive(productId, isActive)); },
        saveCenterNotes: (centerId, notes) => { return dispatch(CenterActionCreators.saveCenterNotes(centerId, notes)); },
        saveCenterCategory: (centerId, category) => { return dispatch(CenterActionCreators.saveCenterCategory(centerId, category)); },
        saveSaturationAnnualGoal: (centerId, goal) => { return dispatch(CenterActionCreators.saveCenterSaturationAnnualGoal(centerId, goal)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterContainer);